export const numberWithCommas = (x) => {
    // taken from https://stackoverflow.com/questions/2901102/how-to-print-a-number-with-commas-as-thousands-separators-in-javascript
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};
//# sourceMappingURL=number_with_commas.js.map